import {
	CreateExternalVehicleDto,
	UpdateExternalVehicleDto,
} from 'models/_external/external-vehicles/interfaces/external-vehicles.interface';
import * as yup from 'yup';

const vehicleValidations = {
	internalId: yup
		.string()
		.matches(/^[a-zA-Z0-9]+$/)
		.required('Campo requerido'),
	description: yup.string().nullable(),
};

export const externalVehicleValidationSchema = yup.object(vehicleValidations);

export const externalVehicleDefaults:
	| UpdateExternalVehicleDto
	| CreateExternalVehicleDto = {
	internalId: undefined,
	description: undefined,
};
